import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Form } from 'cvlib';

import { emailRegex } from '../../utils';
import '../../style.scss';

const EmailForm = props => {
  const {
    email_tooltip_valid_label_validation,
    registerMail_tooltip_error_label,
    registro_mail,
    register_access_option_button_next,
    login_access_placeHolder_textfield,
    password_tooltip_completeField_label_validation,
    Login_accessCV_HboMax_text,
    Login_accessCplay_HboMax_text,
    Login_accessCplay_HboMax_link,
  } = props.translations;
  const [emptyEmail, setEmptyEmail] = useState(true);
  const { onNextClicked, emailValid, hogar, region, hboMaxIsEnabled } = props;

  const onClickRegister = () => {
    let url = `https://www.clarovideo.com/${region}/register`;
    if (hogar) url = Login_accessCplay_HboMax_link;
    window.open(url, '_blank');
  };
  const label = hogar
    ? Login_accessCplay_HboMax_text
    : Login_accessCV_HboMax_text;

  const content = `<a>${label}</a>`;

  const elements = [
    {
      element: 'group',
      direction: 'vertical',
      expand: 0.5,
      children: [
        {
          element: 'subtitle',
          content: registro_mail,
          expand: 0.3,
        },
        {
          element: 'item',
          type: 'email',
          expand: 0.3,
          placeholder: login_access_placeHolder_textfield,
          message: email_tooltip_valid_label_validation,
          error: !emailValid && registerMail_tooltip_error_label,
          name: 'emailRegister',
          id: 'emailRegister',
          autoFocus: true,
          registerOptions: {
            required: password_tooltip_completeField_label_validation,
            pattern: {
              value: emailRegex,
              message: email_tooltip_valid_label_validation,
            },
          },
          onChange: ({ target }) => setEmptyEmail(target.value.length <= 0),
        },
      ],
    },
    {
      element: 'button',
      type: 'red',
      content: register_access_option_button_next,
      expand: 0.2,
      submit: onNextClicked,
      dimmed: emptyEmail,
    },
    hboMaxIsEnabled && {
      element: 'message',
      className: 'hbo-container__span',
      position: 'bottom',
      content,
      expand: 1,
      onClick: onClickRegister,
    },
  ];

  const classes = ['hbo-container', 'content'];

  return <Form elements={elements} classes={classes} />;
};

EmailForm.propTypes = {
  onNextClicked: PropTypes.func.isRequired,
  region: PropTypes.string,
  hogar: PropTypes.bool,
  hboMaxIsEnabled: PropTypes.bool,
  emailValid: PropTypes.bool,
  translations: PropTypes.shape({
    registerMail_tooltip_error_label: PropTypes.string,
    email_tooltip_valid_label_validation: PropTypes.string,
    registro_mail: PropTypes.string,
    register_access_option_button_next: PropTypes.string,
    login_access_placeHolder_textfield: PropTypes.string,
    Login_accessCV_HboMax_text: PropTypes.string,
    Login_accessCplay_HboMax_text: PropTypes.string,
    Login_accessCplay_HboMax_link: PropTypes.string,
  }),
};

EmailForm.defaultProps = {
  emailValid: true,
};

export default EmailForm;
